import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Soft UI Dashboard PRO React example components
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import _ from "lodash";
import ValidationService from "services/ValidationService";
import Helpers from "utils/Helpers";
import Input from "components/CustomFields/Input";
import { useNavigate } from "react-router-dom";

function UserUpdatePassForm() {
  const [password, setPassword] = useState(null);
  const [passwordError, setPasswordError] = useState(false);
  const [oldPassword, setOldPassword] = useState(null);
  const [oldPasswordError, setOldPasswordError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const navigate = useNavigate();

  const handleOldPassword = (val) => {
    setOldPasswordError(false);
    setOldPassword(val);
  };

  const handlePassword = (val) => {
    setPasswordError(false);
    setPassword(val);
  };

  const hanldeConfirmPassword = (val) => {
    setPasswordError(false);
    setConfirmPassword(val);
  };

  const updatePass = async () => {
    const userPass = {
      oldPassword: oldPassword,
      password: password,
      confirmPassword: confirmPassword,
    };

    const error = ValidationService.validateUserPass(userPass);

    if (error) {
      console.error(error.message);
      const errorPath = _.get(error, "details[0].path[0]");
      if (errorPath === "oldPassword") setOldPasswordError(true);
      if (errorPath === "password") setPasswordError(true);
      if (errorPath === "confirmPassword") setPasswordError(true);
      return;
    }

    const response = await ApiService.putData(`/api/v1/users/me/change-password`, userPass);
    if (!response) {
      ToastUtils.error(`Αδυναμία επεξεργασίας κωδικού!`);
      return;
    }

    ToastUtils.success("Επιτυχία επεξεργασίας κωδικού!. Θα μεταφερθείτε στη σύνδεση.");
    await Helpers.waitTimeout(2000);
    navigate("/login");
  };
  return (
    <Grid item xs={12} lg={4}>
      <Card sx={{ overflow: "visible" }}>
        <SoftBox p={2} lineHeight={1}>
          <SoftTypography variant="h6" fontWeight="medium">
            Αλλαγή κωδικού πρόσβασης
          </SoftTypography>
          <SoftTypography variant="button" fontWeight="regular" color="text">
            Συμπληρώσετε τα στοιχεία για να αλλάξετε τον κωδικό σας
          </SoftTypography>
          <Divider />
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Input
                xs={12}
                md={12}
                type="password"
                title="Υπάρχον Κωδικός Πρόσβασης"
                handler={handleOldPassword}
                error={oldPasswordError}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Input
                xs={12}
                md={12}
                type="password"
                title="Νέος Κωδικός Πρόσβασης"
                handler={handlePassword}
                error={passwordError}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Input
                xs={12}
                md={12}
                type="password"
                title="Επαλήθευση Κωδικού Πρόσβασης"
                handler={hanldeConfirmPassword}
                error={passwordError}
              />
            </Grid>
          </Grid>

          <SoftBox display="flex" justifyContent="flex-end" mt={3}>
            <SoftButton
              variant="gradient"
              color="error"
              style={{ width: "100%" }}
              onClick={updatePass}
            >
              ΑΛΛΑΓΗ ΚΩΔΙΚΟΥ
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </Card>
    </Grid>
  );
}

export default UserUpdatePassForm;
